import { colors } from '@bonitour/components'
import { css } from '@emotion/core'

export const externalCodeStyle = css`
  color: ${colors.primary};
  text-decoration: underline;
`
export const hidePopover = css`
  display: none;
`
export const popoverStyle = css`
  display: flex;
  flex-direction: column;
  height: 70px;
  width: 170px;
  align-items: center;
  justify-content: space-evenly;
  transform: none !important;
  top: -99px !important;
  left: -72px !important;
`
export const voucherActionIconSize = css`
  font-size: 18px;
  margin-right: 7px;
`
